"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
ProfileAddressController.$inject = ['$scope', 'api', 'extApi', '_profile', 'notify'];
function ProfileAddressController($scope, api, extApi, _profile, notify) {
    function refresh() {
        extApi.get('/delivery-addresses', { page: 1, per_page: 100 })
            .then(function (items) {
            $scope.addresses = items;
        });
    }
    ;
    refresh();
    $scope.addNew = function () {
        $scope.addresses.data.push({
            is_default: 0,
            address: null,
            city: null,
            contact_phone: null,
            contact_person: null
        });
    };
    $scope.updateDefault = function (address) {
        _.each($scope.addresses.data, function (val) {
            if (val.address_id !== address.address_id) {
                val.is_default = 0;
            }
        });
    };
    $scope.remove = function (item) {
        if (item.address_id) {
            _profile.removeAddress(item).then(function (response) {
                notify.success('Uspešno ste obrisali adresu.');
                refresh();
            }, function (error) {
                notify.error(error.data);
            });
        }
        else {
            _.remove($scope.addresses.data, item);
        }
    };
    $scope.save = function (address) {
        var postData = {
            address_id: address.address_id,
            city: address.city,
            address: address.address,
            is_default: address.is_default,
            contact_person: address.contact_person,
            contact_phone: address.contact_phone
        };
        _profile.saveAddress(postData)
            .then(function (response) {
            refresh();
            notify.success('Uspešno ste sačuvali podatke.');
        }, function (error) {
            console.log(error);
            if (error.data) {
                notify.error(error.data.error.message);
            }
        });
    };
}
exports.ProfileAddressController = ProfileAddressController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/profile/controllers/ProfileAddressController.js
// module id = 435
// module chunks = 0